import React from 'react';
import styled from 'styled-components';
import SkeletonBone from 'web-ui-kit/loaders/SkeletonBone';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function SkeletonLoader(_ref) {
  var mqTwoColumnUp = _ref.mqTwoColumnUp;
  var DescriptionSkeleton = styles.DescriptionSkeleton,
      Grid = styles.Grid,
      ImageSkeleton = styles.ImageSkeleton,
      MainColumn = styles.MainColumn,
      NameSkeleton = styles.NameSkeleton,
      PriceSkeleton = styles.PriceSkeleton,
      SourceSkeleton = styles.SourceSkeleton;
  return (
    /*#__PURE__*/
    React.createElement(Grid, {
      "data-testid": "skeleton-loader",
      mqTwoColumnUp: mqTwoColumnUp
    },
    /*#__PURE__*/
    React.createElement(ImageSkeleton, null),
    /*#__PURE__*/
    React.createElement(MainColumn, null,
    /*#__PURE__*/
    React.createElement(SourceSkeleton, null),
    /*#__PURE__*/
    React.createElement(NameSkeleton, null),
    /*#__PURE__*/
    React.createElement(PriceSkeleton, null),
    /*#__PURE__*/
    React.createElement(DescriptionSkeleton, null)))
  );
}

var styles = {
  Grid: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: 1fr;\n\n    ", " {\n      grid-template-columns: 1fr 1fr;\n      grid-column-gap: 2rem;\n    }\n  "])), function (p) {
    return p.mqTwoColumnUp;
  }),
  DescriptionSkeleton: styled(SkeletonBone)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: 7.375rem;\n    margin-bottom: 2rem;\n  "]))),
  ImageSkeleton: styled(SkeletonBone)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    height: 0;\n    padding-bottom: 100%;\n    margin-bottom: 1rem;\n  "]))),
  MainColumn: styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n  "]))),
  NameSkeleton: styled(SkeletonBone)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    height: 1.5rem;\n    margin-bottom: 0.375rem;\n  "]))),
  PriceSkeleton: styled(SkeletonBone)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    height: 1.5rem;\n    margin-bottom: 2.375rem;\n  "]))),
  SourceSkeleton: styled(SkeletonBone)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    height: 1rem;\n    width: 6.125rem;\n    margin-bottom: 0.75rem;\n  "])))
};
export default SkeletonLoader;